import Image from '@atlaskit/image';

import { Text } from '@atlaskit/primitives/compiled';

import { FormattedMessage, useIntl } from 'react-intl';

import { type marketplaceOpsMessages } from './messages';

import spotlightMediaImage from './assets/spotlight-media.svg';

import { type JSX } from 'react/jsx-runtime';

import { SpotlightPrimaryAction } from '@atlaskit/spotlight/primary-action';

import { SpotlightMedia } from '@atlaskit/spotlight/media';

import { SpotlightHeadline } from '@atlaskit/spotlight/headline';

import { SpotlightHeader } from '@atlaskit/spotlight/header';

import { SpotlightFooter } from '@atlaskit/spotlight/footer';

import { SpotlightDismissControl } from '@atlaskit/spotlight/dismiss-control';

import { SpotlightControls } from '@atlaskit/spotlight/controls';

import { SpotlightCard } from '@atlaskit/spotlight/card';

import { SpotlightBody } from '@atlaskit/spotlight/body';

import { SpotlightActions } from '@atlaskit/spotlight/actions';

import { PopoverTarget } from '@atlaskit/spotlight/popover-target';

import { PopoverProvider } from '@atlaskit/spotlight/popover-provider';

import { PopoverContent } from '@atlaskit/spotlight/popover-content';

export interface OperationsMenuItemSpotlightProps {
	dismiss: () => void;
	onPrimaryAction: () => void;
	messages: typeof marketplaceOpsMessages;
}

export const OperationsMenuItemSpotlight = ({
	dismiss,
	onPrimaryAction,
	messages,
}: OperationsMenuItemSpotlightProps): JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<PopoverProvider>
			<PopoverTarget>
				<div />
			</PopoverTarget>
			<PopoverContent dismiss={dismiss} placement="right-end" isVisible={true}>
				<SpotlightCard>
					<SpotlightHeader>
						<SpotlightHeadline>
							<FormattedMessage {...messages.heading} />
						</SpotlightHeadline>
						<SpotlightControls>
							<SpotlightDismissControl autoFocus={false} />
						</SpotlightControls>
					</SpotlightHeader>
					<SpotlightMedia>
						<Image src={spotlightMediaImage} alt={formatMessage(messages.heading)} />
					</SpotlightMedia>
					<SpotlightBody>
						<Text>
							<FormattedMessage {...messages.description} />
						</Text>
					</SpotlightBody>
					<SpotlightFooter>
						<SpotlightActions>
							<SpotlightPrimaryAction onClick={onPrimaryAction}>
								<FormattedMessage {...messages.primaryAction} />
							</SpotlightPrimaryAction>
						</SpotlightActions>
					</SpotlightFooter>
				</SpotlightCard>
			</PopoverContent>
		</PopoverProvider>
	);
};
